// ===== Loader (only on homepage) =====
document.addEventListener('DOMContentLoaded', () => {
    // Initialize language first (before animations to avoid flash)
    if (typeof initLanguage === 'function') {
        initLanguage();
    }

    const loader = document.getElementById('loader');
    
    if (loader) {
        setTimeout(() => {
            loader.classList.add('hidden');
            document.body.style.overflow = 'auto';
            initAnimations();
        }, 1800);
    } else {
        initAnimations();
    }

    initMobileMenu();
});

// ===== Mobile Menu =====
function initMobileMenu() {
    const toggle = document.getElementById('navToggle');
    const menu = document.getElementById('mobileMenu');

    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
        toggle.classList.toggle('active');
        menu.classList.toggle('open');
        document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
    });

    menu.querySelectorAll('.mobile-menu-link').forEach(link => {
        link.addEventListener('click', () => {
            toggle.classList.remove('active');
            menu.classList.remove('open');
            document.body.style.overflow = '';
        });
    });
}

// ===== Navigation Scroll Effect =====
const nav = document.getElementById('nav');

window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (nav && !nav.classList.contains('nav-scrolled-init')) {
        if (currentScroll > 80) {
            nav.classList.add('scrolled');
        } else {
            nav.classList.remove('scrolled');
        }
    }
});

// ===== Smooth Scroll for Anchor Links =====
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// ===== Hero Image Zoom Effect =====
const heroMedia = document.getElementById('heroMedia');
if (heroMedia) {
    if (heroMedia.complete) {
        heroMedia.classList.add('loaded');
    } else {
        heroMedia.addEventListener('load', () => {
            heroMedia.classList.add('loaded');
        });
    }
}

// ===== Parallax Effect =====
function initParallax() {
    const parallaxSections = document.querySelectorAll('.parallax-section');
    
    window.addEventListener('scroll', () => {
        const scrollY = window.pageYOffset;
        
        parallaxSections.forEach(section => {
            const speed = parseFloat(section.dataset.speed) || 0.3;
            const rect = section.getBoundingClientRect();
            const sectionTop = rect.top + scrollY;
            const offset = (scrollY - sectionTop) * speed;
            
            const imageWrapper = section.querySelector('.parallax-image-wrapper');
            if (imageWrapper && rect.top < window.innerHeight && rect.bottom > 0) {
                imageWrapper.style.transform = 'translateY(' + offset + 'px)';
            }
        });

        if (heroMedia) {
            const heroOffset = scrollY * 0.4;
            const scale = heroMedia.classList.contains('loaded') ? 1 : 1.1;
            heroMedia.style.transform = 'scale(' + scale + ') translateY(' + heroOffset + 'px)';
        }
    });
}

// ===== Fade-in Animations (Intersection Observer) =====
function initFadeAnimations() {
    const fadeElements = document.querySelectorAll('.fade-up');
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const delay = parseInt(entry.target.dataset.delay) || 0;
                setTimeout(() => {
                    entry.target.classList.add('visible');
                }, delay);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px'
    });
    
    fadeElements.forEach(el => observer.observe(el));
}

// ===== Gallery Hover Effect =====
function initGalleryEffects() {
    const galleryItems = document.querySelectorAll('.gallery-item');
    
    galleryItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            galleryItems.forEach(other => {
                if (other !== item) {
                    other.style.opacity = '0.5';
                    other.style.transition = 'opacity 0.5s ease';
                }
            });
        });
        
        item.addEventListener('mouseleave', () => {
            galleryItems.forEach(other => {
                other.style.opacity = '1';
            });
        });
    });
}

// ===== Booking Form (Homepage) =====
function initBookingForm() {
    const form = document.getElementById('bookingForm');
    const successEl = document.getElementById('bookingSuccess');
    const resetBtn = document.getElementById('resetBtn');
    const submitBtn = document.getElementById('submitBtn');

    if (!form) return;

    const today = new Date().toISOString().split('T')[0];
    const arrivalInput = document.getElementById('arrivalDate');
    const departureInput = document.getElementById('departureDate');
    if (arrivalInput) arrivalInput.setAttribute('min', today);
    if (departureInput) departureInput.setAttribute('min', today);

    if (arrivalInput) {
        arrivalInput.addEventListener('change', () => {
            if (arrivalInput.value) {
                const nextDay = new Date(arrivalInput.value);
                nextDay.setDate(nextDay.getDate() + 1);
                departureInput.setAttribute('min', nextDay.toISOString().split('T')[0]);
                if (departureInput.value && departureInput.value <= arrivalInput.value) {
                    departureInput.value = '';
                }
            }
        });
    }

    form.querySelectorAll('.form-input').forEach(input => {
        input.addEventListener('input', () => {
            input.classList.remove('error');
            const errorEl = document.getElementById(input.id + 'Error');
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('visible');
            }
        });
    });

    function validateBookingForm() {
        let isValid = true;
        const fields = [
            { id: 'guestName', message: 'Please enter your name' },
            { id: 'guestEmail', message: 'Please enter a valid email' },
            { id: 'arrivalDate', message: 'Please select arrival date' },
            { id: 'departureDate', message: 'Please select departure date' },
            { id: 'guestCount', message: 'Please select number of guests' }
        ];

        fields.forEach(field => {
            const input = document.getElementById(field.id);
            const errorEl = document.getElementById(field.id + 'Error');
            if (!input) return;
            let hasError = false;

            if (!input.value.trim()) {
                hasError = true;
            }

            if (field.id === 'guestEmail' && input.value.trim()) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(input.value.trim())) {
                    hasError = true;
                    field.message = 'Please enter a valid email address';
                }
            }

            if (field.id === 'departureDate' && input.value && arrivalInput && arrivalInput.value) {
                if (input.value <= arrivalInput.value) {
                    hasError = true;
                    field.message = 'Departure must be after arrival';
                }
            }

            if (hasError) {
                isValid = false;
                input.classList.add('error');
                if (errorEl) {
                    errorEl.textContent = field.message;
                    errorEl.classList.add('visible');
                }
            }
        });

        return isValid;
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (!validateBookingForm()) return;

        submitBtn.disabled = true;
        submitBtn.classList.add('loading');

        const booking = {
            id: Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
            name: document.getElementById('guestName').value.trim(),
            email: document.getElementById('guestEmail').value.trim(),
            arrivalDate: document.getElementById('arrivalDate').value,
            departureDate: document.getElementById('departureDate').value,
            guests: document.getElementById('guestCount').value,
            submittedAt: new Date().toISOString()
        };

        const bookings = JSON.parse(localStorage.getItem('sacredJannahBookings') || '[]');
        bookings.push(booking);
        localStorage.setItem('sacredJannahBookings', JSON.stringify(bookings));

        setTimeout(() => {
            form.style.display = 'none';
            successEl.classList.add('visible');
            submitBtn.disabled = false;
            submitBtn.classList.remove('loading');
        }, 1200);
    });

    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            successEl.classList.remove('visible');
            form.style.display = 'block';
            form.reset();
        });
    }
}

// ===== Registration Form =====
function initRegistrationForm() {
    const form = document.getElementById('registrationForm');
    const successEl = document.getElementById('regSuccess');
    const resetBtn = document.getElementById('regResetBtn');
    const submitBtn = document.getElementById('regSubmitBtn');

    if (!form) return;

    form.querySelectorAll('.form-input').forEach(input => {
        input.addEventListener('input', () => {
            input.classList.remove('error');
            const errorEl = document.getElementById(input.id + 'Error');
            if (errorEl) {
                errorEl.textContent = '';
                errorEl.classList.remove('visible');
            }
        });
    });

    function validateRegistrationForm() {
        let isValid = true;
        const requiredFields = [
            { id: 'regFirstName', message: 'Please enter your first name' },
            { id: 'regLastName', message: 'Please enter your last name' },
            { id: 'regEmail', message: 'Please enter a valid email' },
            { id: 'regPhone', message: 'Please enter your phone number' },
            { id: 'regCountry', message: 'Please enter your country' },
            { id: 'regRetreatDate', message: 'Please select a retreat date' },
            { id: 'regGuests', message: 'Please select number of guests' }
        ];

        requiredFields.forEach(field => {
            const input = document.getElementById(field.id);
            const errorEl = document.getElementById(field.id + 'Error');
            if (!input) return;
            let hasError = false;

            if (!input.value.trim()) {
                hasError = true;
            }

            if (field.id === 'regEmail' && input.value.trim()) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(input.value.trim())) {
                    hasError = true;
                    field.message = 'Please enter a valid email address';
                }
            }

            if (hasError) {
                isValid = false;
                input.classList.add('error');
                if (errorEl) {
                    errorEl.textContent = field.message;
                    errorEl.classList.add('visible');
                }
            }
        });

        return isValid;
    }

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (!validateRegistrationForm()) return;

        submitBtn.disabled = true;
        submitBtn.classList.add('loading');

        const registration = {
            id: Date.now().toString(36) + Math.random().toString(36).slice(2, 7),
            firstName: document.getElementById('regFirstName').value.trim(),
            lastName: document.getElementById('regLastName').value.trim(),
            email: document.getElementById('regEmail').value.trim(),
            phone: document.getElementById('regPhone').value.trim(),
            country: document.getElementById('regCountry').value.trim(),
            ageRange: document.getElementById('regAge').value || '',
            retreatDate: document.getElementById('regRetreatDate').value,
            guests: document.getElementById('regGuests').value,
            healthGoals: document.getElementById('regHealthGoals').value.trim(),
            dietary: document.getElementById('regDietary').value.trim(),
            medical: document.getElementById('regMedical').value.trim(),
            hearAbout: document.getElementById('regHearAbout').value || '',
            message: document.getElementById('regMessage').value.trim(),
            submittedAt: new Date().toISOString()
        };

        const registrations = JSON.parse(localStorage.getItem('sacredJannahRegistrations') || '[]');
        registrations.push(registration);
        localStorage.setItem('sacredJannahRegistrations', JSON.stringify(registrations));

        setTimeout(() => {
            form.style.display = 'none';
            successEl.classList.add('visible');
            submitBtn.disabled = false;
            submitBtn.classList.remove('loading');
        }, 1200);
    });

    if (resetBtn) {
        resetBtn.addEventListener('click', () => {
            successEl.classList.remove('visible');
            form.style.display = 'block';
            form.reset();
        });
    }
}

// ===== Initialize All Animations =====
function initAnimations() {
    initParallax();
    initFadeAnimations();
    initGalleryEffects();
    initBookingForm();
    initRegistrationForm();
}

/* ============================================================
   SACRED JANNAH — AJAX CART ENGINE (appended)
   Drawer, add-to-cart, qty changes, live count + subtotal.
   Progressive enhancement: all forms still work without JS.
   ============================================================ */
(function () {
  'use strict';

  var SJ = window.SJ || {};
  var CART_URL = SJ.cartUrl || '/cart';
  var STR = SJ.strings || {};

  // ---- Money formatting (mirrors Shopify's money_format) ----
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || SJ.moneyFormat || '{{amount}}';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function thousands(number, precision, thousandsSep, decimalSep) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousandsSep = thousandsSep == null ? ',' : thousandsSep;
      decimalSep = decimalSep == null ? '.' : decimalSep;
      var num = (cents / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var centsPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + centsPart;
    }

    switch (fmt.match(placeholderRegex) ? fmt.match(placeholderRegex)[1] : 'amount') {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'"); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  // ---- DOM helpers ----
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var drawer = $('#cartDrawer');
  var overlay = $('#cartDrawerOverlay');
  var drawerBody = $('#cartDrawerBody');
  var drawerFoot = $('#cartDrawerFoot');

  function openDrawer() {
    if (!drawer) { window.location.href = CART_URL; return; }
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ---- Update header count bubbles ----
  function updateCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
      el.classList.remove('cart-bump');
      void el.offsetWidth; // reflow to restart animation
      if (count > 0) el.classList.add('cart-bump');
    });
  }

  // ---- Render mini-cart drawer from /cart.js ----
  function renderDrawer(cart) {
    if (!drawerBody) return;
    updateCount(cart.item_count);

    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<p class="cart-drawer-empty">' + (STR.empty || 'Your cart is empty.') + '</p>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var variantTxt = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<span class="mini-line-variant">' + item.variant_title + '</span>' : '';
      var img = item.image
        ? '<img class="mini-line-img" src="' + item.image.replace(/(\.[^.\/]*)?(\?|$)/, '_120x150$1$2') + '" alt="">'
        : '<span class="mini-line-img"></span>';
      html += '' +
        '<div class="mini-line" data-key="' + item.key + '">' +
          '<a href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="mini-line-title" href="' + item.url + '">' + item.product_title + '</a>' +
            variantTxt +
            '<div class="mini-line-qty">' +
              '<button type="button" data-mini-minus aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-mini-plus aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<div class="mini-line-price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button type="button" class="mini-line-remove" data-mini-remove>' + (STR.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>';
    });
    drawerBody.innerHTML = html;

    if (drawerFoot) {
      drawerFoot.hidden = false;
      var sub = $('[data-cart-subtotal]', drawerFoot);
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
  }

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() { return fetchCart().then(renderDrawer); }

  // ---- Add to cart ----
  function addToCart(form, button) {
    var formData = new FormData(form);
    if (button) button.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refreshDrawer(); })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        alert((err && err.description) || STR.error || 'Could not add to cart.');
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  // ---- Change line quantity (by key) ----
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  // ---- Global click handling ----
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); refreshDrawer().then(openDrawer); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    // Mini-cart qty / remove
    var miniLine = e.target.closest('.mini-line');
    if (miniLine) {
      var key = miniLine.getAttribute('data-key');
      var qtySpan = miniLine.querySelector('.mini-line-qty span');
      var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      if (e.target.closest('[data-mini-plus]')) { changeLine(key, current + 1).then(renderDrawer); return; }
      if (e.target.closest('[data-mini-minus]')) { changeLine(key, Math.max(0, current - 1)).then(renderDrawer); return; }
      if (e.target.closest('[data-mini-remove]')) { changeLine(key, 0).then(renderDrawer); return; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ---- Add-to-cart forms (cards + PDP) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('button[type="submit"]'));
  });

  // ---- PDP enhancements ----
  function initPDP() {
    var variantSelect = $('[data-pdp-variant]');
    var priceEl = $('#pdpPrice');
    if (variantSelect && variantSelect.tagName === 'SELECT' && priceEl) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        if (price) {
          priceEl.innerHTML = compare
            ? '<span class="price-sale">' + price + '</span> <s class="price-was">' + compare + '</s>'
            : price;
        }
      });
    }

    // qty steppers
    $all('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('[data-qty-input]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
    });
    $all('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('[data-qty-input]');
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    // PDP gallery thumbnails
    var mainImg = $('#pdpMainImage');
    $all('.pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-full');
        $all('.pdp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  // ---- Cart page enhancements (AJAX qty + remove) ----
  function initCartPage() {
    var pageForm = $('[data-cart-page-form]');
    if (!pageForm) return;

    function setLine(key, qty) {
      changeLine(key, qty).then(function () { window.location.reload(); });
    }

    pageForm.addEventListener('click', function (e) {
      var item = e.target.closest('.cartpage-item');
      if (!item) return;
      var input = item.querySelector('[data-line-qty]');
      var key = item.getAttribute('data-key');
      var current = input ? (parseInt(input.value, 10) || 0) : 0;

      if (e.target.closest('[data-line-plus]')) { e.preventDefault(); setLine(key, current + 1); }
      else if (e.target.closest('[data-line-minus]')) { e.preventDefault(); setLine(key, Math.max(0, current - 1)); }
      else if (e.target.closest('[data-line-remove]')) { e.preventDefault(); setLine(key, 0); }
    });

    pageForm.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-qty]');
      if (!input) return;
      setLine(input.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPDP();
    initCartPage();
  });
})();
